import React, {Fragment} from 'react';
import RenderInput from "./RenderInput";
import {addWidthToTextArea} from "./functions";


const MagicFormInput = (props) => {
  const {myData, setMyData} = props
  try {
    return myData?.filteredFormConfig?.map((row, index) => {
      const rowType = row.type;

      // یه موردی هست
      // من دوس دارم این مورد از بک تایین بشه که آیا این اینپوت باید 100 از فضا رو بگیره یا نه
      // اگه از بک باشه باید به آبجکت رو یه کلید اضافه کنه.
      // فعلا دستی خودم این کلید رو طبق شرایط خاص نشون میدم

      row.width = addWidthToTextArea(row) // here is useless until backend set width key
      const rowWidth = row.width

      if (row?.visible === true) {
        return <div key={index + "-" + index}
                    className={rowWidth === '100%' ? 'form__item expand__to__100' : 'form__item item'}
        >
          <div className={'div__group__input_select'}>
            <label htmlFor="">{row?.title} {row?.required ? <span className={'text-danger'}>*</span> : ''}</label>
            <RenderInput myData={myData} setMyData={setMyData} row={row} index={index}/>
          </div>
          <small className={row?.errorMessage ? 'text-danger' : ''}
                 style={{
                   position: 'absolute', fontSize: 10,

                 }}
          >{row?.errorMessage} </small>
        </div>
      }
      return <>
        {!row?.type && <ul className={"list-decimal"}>
          <li className={"alert alert-danger"}> {row.title}</li>
          <li className={"alert alert-danger"}> تایپ مشخص نیست</li>
        </ul>}
      </>
    });
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default React.memo(MagicFormInput);